export const GET_EMAILID_BY_TOKEN = 'GET_EMAILID_BY_TOKEN';
export const GET_EMAILID_BY_TOKEN_SUCCESS = 'GET_EMAILID_BY_TOKEN_SUCCESS';
export const GET_EMAILID_BY_TOKEN_ERROR = 'GET_EMAILID_BY_TOKEN_ERROR';

export const GET_REWARDS_PROFILE = 'GET_REWARDS_PROFILE';
export const GET_REWARDS_PROFILE_SUCCESS = 'GET_REWARDS_PROFILE_SUCCESS';
export const GET_REWARDS_PROFILE_ERROR = 'GET_REWARDS_PROFILE_ERROR';
